import { ChannelValue, UserValue, Value } from 'components/ShareSheet/RecipientSelector/Types'
import { RecipientsSelectorValueType } from 'types'

export const dehydrateInvites = (invites: Value[]) => {
  return {
    emails: invites
      .filter(({ type }) => type === RecipientsSelectorValueType.Email)
      .map(({ value }) => value as string),
    channels: invites
      .filter(({ type }) => type === RecipientsSelectorValueType.Channel)
      .map(({ value }) => (value as ChannelValue['value']).id),
    users: invites
      .filter(({ type }) => type === RecipientsSelectorValueType.User)
      .map(({ value }) => (value as UserValue['value']).id),
  }
}
